import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@Src/app/hooks';
import { AppRouteURL } from '@Constants/app-route-url.constant';
import { getUserDetails } from '@Features/UserProfile/Services/UserProfile.sevice';
import { USE_MOCK_DATA, getMockUserDetails } from '@Src/mocks/subscriptionMockData';

export const useAnalyticsAccess = () => {
    const navigate = useNavigate();
    const loginData = useAppSelector((state: any) => state.login);
    const isLoggedIn = loginData?.isLoggedIn;

    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [hasAnalyticsAccess, setHasAnalyticsAccess] = useState(false);

    useEffect(() => {
        checkAnalyticsAccess();
    }, []);

    const checkAnalyticsAccess = async () => {
        if (!isLoggedIn) {
            navigate(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY);
            return;
        }

        try {
            setIsCheckingAccess(true);
            // Fetch analytics access from API
            // OR use mock data if testing flag is enabled
            const response: any = USE_MOCK_DATA
                ? await getMockUserDetails()
                : await getUserDetails();

            if (response?.ResponseType === 'SUCCESS' && response?.data?.[0]) {
                const userDetails = response.data[0];
                const {
                    last_student_subscription_rel_id,
                    Student_sub_ShowAnalytics,
                    Institute_sub_PlanName,
                    Institute_sub_ShowAnalytics
                } = userDetails;

                // Check if user has analytics access
                let hasAccess = false;

                // Student subscription exists
                if (last_student_subscription_rel_id) {
                    hasAccess = Student_sub_ShowAnalytics === 1;
                }
                // Institute subscription exists
                else if (Institute_sub_PlanName) {
                    hasAccess = Institute_sub_ShowAnalytics === 1;
                }

                setHasAnalyticsAccess(hasAccess);


            } else {
                // If API fails, redirect to test activity
                navigate(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY);
            }
        } catch (error) {
            console.error('Error checking analytics access:', error);
            navigate(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY);
        } finally {
            setIsCheckingAccess(false);
        }
    };

    return {
        isCheckingAccess,
        hasAnalyticsAccess
    };
};
